import React, { Component } from "react"
import PropTypes from "prop-types"
import classnames from "classnames"

import styles from "./styles.less"

export default class CollapsiblePanel extends Component {
  static defaultProps = {
    className: "",
  }

  static propTypes = {
    title: PropTypes.string,
    className: PropTypes.string,
  }

  state = {
    isCollapsed: false,
    collapsing: false,
  }

  componentDidMount() {
    this.recalculateBodyHeight()
  }

  recalculateBodyHeight() {
    this.bodyOriginalHeight = this.bodyElement.clientHeight
  }

  handleThrottledToggle = _.throttle(
    function () {
      if (!this.state.isCollapsed) {
        this.recalculateBodyHeight()
        this.setState({ bodyHeight: this.bodyOriginalHeight })
      }
      setTimeout(
        function () {
          this.setState((prevState) => ({
            collapsing: true,
            bodyHeight: prevState.isCollapsed ? this.bodyOriginalHeight : "0",
          }))
          setTimeout(
            function () {
              if (this.state.isCollapsed) this.recalculateBodyHeight()
              this.setState((prevState) => ({
                collapsing: false,
                isCollapsed: !prevState.isCollapsed,
                bodyHeight: prevState.isCollapsed ? "auto" : "0",
              }))
            }.bind(this),
            350,
          )
        }.bind(this),
        0,
      )
    }.bind(this),
    350,
    { trailing: false },
  )

  render() {
    var panelClass = classnames(
      styles.collapsiblePanel,
      this.state.isCollapsed ? styles.collapsed : null,
      this.state.collapsing ? styles.collapsing : null,
    )
    return (
      <div className={panelClass}>
        <div
          className={`${styles.header} section-filter-header`}
          onClick={this.handleThrottledToggle.bind(this)}>
          {this.props.title}
          <i
            className={classnames(
              "fa align-right collapse-icon",
              this.state.isCollapsed ? "fa-plus" : "fa-minus",
            )}
          />
        </div>
        <div
          className={styles.body}
          style={{ height: this.state.bodyHeight }}
          ref={(bodyElement) => (this.bodyElement = bodyElement)}>
          {this.props.children}
        </div>
      </div>
    )
  }
}
